import type { ApiClient } from '@prismo-io/schemas';

export const kickExperience = async (client: ApiClient) => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    throw new Error('You must be connected.');
  }

  await client
    .from('users')
    .update({
      has_kick_experience: true,
    })
    .eq('id', session.user.id);

  return true;
};
